export default __webpack_public_path__ + "static/media/pag18.5a4d9406.jpg";